import { Link, Outlet, createRootRoute, useMatchRoute } from "@tanstack/react-router";

import { NotFoundState } from "@components/not-found-state";
import { PrintButton } from "@components/print-button";

function RootLayout() {
  const matchRoute = useMatchRoute();
  // Only a doc is worth putting on paper; the index would print as a list of links.
  const onDoc = Boolean(matchRoute({ to: "/d/$slug" }));

  return (
    <div className="min-h-dvh">
      <header className="border-border bg-background sticky top-0 z-20 flex h-(--shell-header) items-center justify-between gap-ming-4 border-b px-ming-4 sm:px-ming-6 print:hidden">
        <Link to="/" className="text-foreground text-body font-medium">
          Ming
        </Link>
        {onDoc ? <PrintButton /> : null}
      </header>
      <Outlet />
    </div>
  );
}

export const Route = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundState,
});
